import { DirectReportsType, WorkExperienceType } from '@talentmesh/utils';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import { TestTypes } from '@/Models/Configuration';

export interface RecruitmentSpecificationDTO {
    name: string;
    locationId?: string;
    jobLocation?: string;
    clientId: string;
    jobFunctionId: number;
    assessmentId: string;
    workExperience: WorkExperienceType;
    includedTests: TestTypes[];
    directReports: DirectReportsType;
    assessmentStatus: AssessmentStatuses;
    includesExperienceCriteria: boolean;
}

export const DefaultRecruitmentSpecificationDTO: RecruitmentSpecificationDTO = {
    name: '',
    locationId: undefined,
    jobLocation: undefined,
    clientId: '',
    jobFunctionId: 0,
    assessmentId: '',
    workExperience: 'GraduateOrAnalyst',
    includedTests: [],
    directReports: 'None',
    assessmentStatus: AssessmentStatuses.Active,
    includesExperienceCriteria: false,
};
